import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthSignedInGuardService } from 'src/@core/http/auth/auth-signedin-guard.service';
import { AuthGuardService } from 'src/@core/http/auth/auth-guard.service';
import { Role } from 'src/@core/http';
import { AgmCoreModule } from '@agm/core';
import { GOOGLEMAP_KEY } from '../@shared/constants';

const routes: Routes = [
    { path: 'admin', loadChildren: '../app/layout/layout.module#LayoutModule', canActivate: [AuthGuardService], data: {roles: [Role.Admin]}},
    { path: 'login', loadChildren: '../app/login/login.module#LoginModule', canActivate: [AuthSignedInGuardService] },
    { path: 'customer', loadChildren: './customer-portal/customer-portal.module#CustomerPortalModule' },
	{ path: '', redirectTo: '/login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class AppRoutingModule { }

export const routedComponents = [];
